import { FormControl, TextField } from "@mui/material";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import localize from "../../../common/localize";
import useGlobalContext from "../../../hooks/useGlobalContext";
import PageTitleSubtitle from "../../../components/PageTitleSubTitle";
import FieldTextField from "../../../components/common/FieldTextfield";

const AddOrEditPage = () => {
  const { pageModel, setPageModel, dynamicFormModel, userName } =
    useGlobalContext();

  const handleChangePageName = (e) => {
    setPageModel({
      ...pageModel,
      DynamicFormId: dynamicFormModel.Id,
      CreatedBy: userName,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <div className="w-full">
      <FieldTextField
        customMinWidth="50%"
        isRequired
        fieldName="Name"
        fieldTitle={localize.page_name}
        fieldSubtitle={localize.page_name_description}
        handleValueChange={handleChangePageName}
        fieldValue={pageModel?.Name}
      />
    </div>
  );
};

export default AddOrEditPage;
